import { apiGetOptional } from '@/api/http';

export const getMagicLink = (query: string) =>
  apiGetOptional<{ link?: string }>(`${import.meta.env.VITE_API_URL}${query}`);
